/**
 * Illustrative real-world equivalences for the end-of-run summary. Rounded
 * industry averages, disclaimed in the UI as "illustrative, US grid averages".
 */
const CONVERSIONS = {
  /** kg CO2 avoided per kWh vs the average US grid mix (EPA ~0.39). */
  co2PerKwh: 0.39,
  /** Rough US residential retail electricity price ($/kWh). */
  dollarsPerKwh: 0.16,
  /** Average US home continuous draw (~30 kWh/day, so ~1.25 kW). */
  homeKw: 1.25,
  /** Energy to fully charge a typical smartphone (~19 Wh). */
  kwhPerPhoneCharge: 0.019,
};

export type RunEquivalences = {
  co2Kg: number;
  dollars: number;
  homeHours: number;
  phoneCharges: number;
};

export const summarize = (energyKwh: number): RunEquivalences => ({
  co2Kg: energyKwh * CONVERSIONS.co2PerKwh,
  dollars: energyKwh * CONVERSIONS.dollarsPerKwh,
  homeHours: energyKwh / CONVERSIONS.homeKw,
  phoneCharges: energyKwh / CONVERSIONS.kwhPerPhoneCharge,
});

/** Distance is tracked in meters internally; a US audience sees it in feet. */
export const metersToFeet = (meters: number): number => meters * 3.28084;
